import React from 'react'
import { FormattedMessage } from 'react-intl'
import manoLlavesCirculo from '../../assets/img/mano-llaves-circulo.png'

class Ventajas extends React.Component {
    render() {
        return (
            <div className="ventajas container">
                <div className="text">
                    <h2>
                        <FormattedMessage id="ventajas" defaultMessage="Ventajas" />
                    </h2>
                    <ul>
                        <li>
                            <FormattedMessage id="sin_llaves_ahorras_tiempo_y_dinero" defaultMessage="Sin llaves ahorras tiempo y dinero" />
                            <br />
                            <FormattedMessage
                                id="evita_los_problemas_ocasionados_por_la_existencia_de_llaves_físicas_entrega_y_recogida_pérdida_duplicados_etc"
                                defaultMessage="Evita los problemas ocasionados por la existencia de llaves físicas (entrega y recogida, pérdida, duplicados, etc.)"
                            />
                        </li>
                        <li>
                            <FormattedMessage id="gana_en_comodidad_y_ofrece_mejor_servicio" defaultMessage="Gana en comodidad y ofrece mejor servicio" />
                            <br />
                            <FormattedMessage
                                id="gestiona_tus_usuarios_de_forma_cómoda_y_sencilla_a_través_de_la_web_o_de_la_propia_app_el_sistema_permite_dar_acceso_a_los_diferentes_usuarios_a_una_o_varias_estancias_durante_un_período_de_tiempo_determinado_definido_por_ti"
                                defaultMessage="Gestiona tus usuarios de forma cómoda y sencilla a través de la web o de la propia app. El sistema permite dar acceso a los diferentes usuarios a una o varias estancias durante un período de tiempo determinado definido por ti."
                            />
                        </li>
                        <li>
                            <FormattedMessage id="libertad_de_movimiento" defaultMessage="Libertad de movimiento" />
                            <br />
                            <FormattedMessage
                                id="podras_abrir_cualquier_puerta_desde_donde_te_encuentres_olvidate_de_las_esperas"
                                defaultMessage="Podrás abrir cualquier puerta desde donde te encuentres, olvídate de las esperas"
                            />
                        </li>
                        <li>
                            <FormattedMessage id="facilidad_de_uso" defaultMessage="Facilidad de uso" />
                            <br />
                            <FormattedMessage
                                id="gestiona_los_permisos_desde_una_interfaz_intuitiva_y_sencilla_permite_el_acceso_cuando_quieras_y_durante_el_tiempo_que_necesites_podrás_usar_tú_móvil_o_la_web"
                                defaultMessage="Gestiona los permisos desde una interfaz intuitiva y sencilla. Permite el acceso cuando quieras y durante el tiempo que necesites. Podrás usar tú móvil o la web"
                            />
                        </li>
                    </ul>
                </div>
            </div>
        )
    }
}

export default Ventajas



// WEBPACK FOOTER //
// ./src/components/home/Ventajas.js